var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7174 1.26904H14.9663L10.053 6.8847L15.8332 14.5264H11.3073L7.76253 9.89174L3.70647 14.5264H1.45613L6.71146 8.51977L1.1665 1.26904H5.80724L9.01143 5.50526L12.7174 1.26904ZM11.928 13.1802H13.1742L5.1301 2.54446H3.79281L11.928 13.1802Z",
    fill: "#686E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.3b2165c8559fbc4259ba9b07a1505bda.svg";
export { ForwardRef as ReactComponent };